import React from 'react';
import classes from './Navigation.module.scss';

import {connect} from "react-redux";

import NavigationItem from './NavigationItem/NavigationItem';

const navigation = ( props ) => {

    let navigationItems = [];

    let QuestionsData = require( '../../data/' + props.mode + '-questions.js' );

    for( let i = 0; i < props.totalItems; i++ ) {
        let complete = false;
        let active = false;

        if( props.currentItem > i ) {
            complete = true;
        } else if( props.currentItem === i ) {
            active = true;
        }

        navigationItems.push(
            <NavigationItem key={i}
                            index={i}
                            complete={complete}
                            active={active}
                            current={props.currentItem}
                            version={props.version}
                            onItemClick={props.onItemClick}
            />
        );
    }

    return (
        <div className={classes.Navigation}>
            <span className={[classes.Label, classes['FG-' + QuestionsData[ props.version ][props.currentItem].color_scheme]].join(' ')}>Progress</span>
            {navigationItems}
        </div>
    );

};

const mapStateToProps = state => {
    return {
        mode: state.mode
    }
};

export default connect( mapStateToProps )( navigation );
